function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    stroke: "currentColor",
    fill: "currentColor",
    focusable: "false",
    "data-icon": "menu-fold",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.482 1.283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.386 14.888 4.334 11V4.533L15.386.65z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(.65 4.533)",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    },
    d: "M0 0h3.684v6.472H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.945 12.318v2.043a1.806 1.806 0 1 1-3.611 0v-3.356",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.3px",
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.b0ac3deab6c8b892e42dd7e3ac5cd7b4.svg";
export { ForwardRef as ReactComponent };